/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { PROVIDER } from "~/constants/cloudProviderConst";
import {
  getConsoleURLs,
  mapResource,
  InputResource,
  ConsoleUrls,
  getAzurePortalURLs,
  getGCPConsoleURLs,
} from "./utils";

const ACCESSOR = "loginURL";

function isValidUrl(consoleUrls: ConsoleUrls) {
  return ACCESSOR in consoleUrls;
}

function getUrl(resource: InputResource): string | undefined {
  switch (resource.provider) {
    case PROVIDER.AWS: {
      const url = getConsoleURLs(mapResource(resource));
      return isValidUrl(url) ? url.loggedInURL : undefined;
    }
    case PROVIDER.AZURE:
      return getAzurePortalURLs(resource);
    case PROVIDER.GCP:
      return getGCPConsoleURLs(resource);
    default:
      return undefined;
  }
}

/**
 * Returns helper function to get provider console url
 */
function useConsoleUrl(): { getUrl: typeof getUrl };

/**
 * Returns provider console url
 * @param resource - Estate resource
 */
function useConsoleUrl(resource: InputResource): {
  url: ReturnType<typeof getUrl>;
};

function useConsoleUrl(resource?: InputResource) {
  if (typeof resource === "undefined") {
    return { getUrl };
  }

  return { url: getUrl(resource) };
}

export default useConsoleUrl;
